const VerticalStepper = ({ steps = [] }) => {
  return (
    <div className="vertical-stepper">
      {steps.map((step, index) => {
        let markerClass = '';
        let markerContent = index + 1;

        switch (step.status) {
          case 'Completed':
            markerClass = 'completed';
            markerContent = '✔';
            break;
          case 'Current':
            markerClass = 'current';
            break;
          case 'Cancelled':
            markerClass = 'cancelled';
            markerContent = '✖';
            break;
          default:
            markerClass = '';
        }

        return (
          <div key={index} className="step-item">
            <div className={`step-marker ${markerClass}`}>
              {markerContent}
            </div>
            <div className="step-content">
              <h6 className="m-0">{step.title}</h6>
              <span style={{fontSize:12}}>{step?.dateTime}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalStepper;
